document.addEventListener('DOMContentLoaded', () => {
    const topBackButton = document.getElementById('top-back-button');
    let previousSteps = [];
    let formState = {
        currentStep: 0,
        doYouOwnSodaMaker: null,
        whatBrandOfSodaMakerDoYouOwn: null,
        whatSodaMakerDoYouOwn: null,
        howManyCanisters: null,
        canisterType: null,
        selectedProductRecommendations: [],
    };

    let canisterTypeElement = document.getElementById('canister-type');
    let progressBarElement = document.getElementById('progress-bar');
    const back = document.getElementById('top-back-button');

    const searchInput = document.getElementById('brand-search');
    const brandMachineDropdown = document.getElementById('brandMachineDropdown');
    const dropdownButtons = brandMachineDropdown.querySelectorAll('button');
    const machineElements = document.querySelectorAll('.soda-machine');

    // Add logging for skip button element
    const skipButton = document.querySelector('[data-skip-form]');

    function transitionToStep4() {
        const step4Element = document.querySelector(`[data-step="4"]`);
        step4Element.classList.add('active');

        setTimeout(() => {
            step4Element.classList.remove('opacity-0', 'pointer-events-none');
            document.getElementById('recommended-product-add-to-cart').classList.remove('opacity-0', 'pointer-events-none');
        }, 50);

        progressBarElement.style.width = '100%';
        setStepInUrl(4);
        updateState('currentStep', 4);

        const recommendedProduct = getProductRecommendations();
        if (recommendedProduct) {
            const variantSelect = document.getElementById('variant-select');
            variantSelect.innerHTML = '';

            recommendedProduct.variants.forEach((variant) => {
                const option = document.createElement('option');
                option.value = variant.id;
                const connectionType = formState.canisterType === 'easy-connect' ? 'Easy Connect' : 'Threaded';
                option.innerHTML = `${variant.title.match(/\d+/)[0]}x ${connectionType} Canister${variant.title.includes('2') ? 's' : ''}`;
                variantSelect.appendChild(option);
            });

            // Select the appropriate variant based on canister count
            let recommendedVariant;
            if (formState.howManyCanisters === '0') {
                recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('3'));
            } else if (formState.howManyCanisters === '1') {
                recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('2'));
            } else if (formState.howManyCanisters === '2') {
                recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('1'));
            } else {
                recommendedVariant = recommendedProduct.variants[0];
            }

            if (recommendedVariant) {
                variantSelect.value = recommendedVariant.id;
                const addToCartBtn = document.querySelector('.add-to-cart-btn');
                addToCartBtn.setAttribute('data-variant-id', recommendedVariant.id);
                const sellingPlanId = (recommendedVariant.selling_plan_allocations || [])[0]?.selling_plan_id || '';
                addToCartBtn.setAttribute('data-selling-plan', sellingPlanId);
                const price = (recommendedVariant.price / 100).toFixed(0);
                addToCartBtn.textContent = `Add to cart - $${price}`;
                if (typeof updateButtonRulesFromProduct === 'function') {
                    updateButtonRulesFromProduct(addToCartBtn, recommendedProduct);
                }

                // Update the recommended product price display
                document.querySelectorAll('.recommended-product-price').forEach((element) => {
                    element.innerHTML = `$${price}`;
                });

                // Update the recommended product title
                document.querySelectorAll('.recommended-product-title').forEach((element) => {
                    element.innerHTML = recommendedProduct.title;
                });
            }
        }
    }

    skipButton?.addEventListener('click', () => {
        const currentStep = document.querySelector('[data-step].active');
        if (currentStep) {
            updateStepHistory('3');
            updateStepHistory('4');

            currentStep.classList.remove('active');
            currentStep.classList.add('opacity-0', 'pointer-events-none');

            setTimeout(() => {
                transitionToStep4();
            }, 700);
        }
    });

    window.displayFizzQuizResults = function (form, submissionResult) {
        const currentStep = document.querySelector('[data-step].active');
        if (currentStep) {
            currentStep.classList.remove('active');
            currentStep.classList.add('opacity-0', 'pointer-events-none');

            setTimeout(() => {
                transitionToStep4();
            }, 700);
        }
    };

    function updateState(key, value) {
        formState[key] = value;
        sessionStorage.setItem('formState', JSON.stringify(formState));

        if (key === 'howManyCanisters' || key === 'canisterType') {
            // Get the recommended product
            const recommendedProduct = getProductRecommendations();
            if (!recommendedProduct) return;

            const recommendedCanisterCount = formState.howManyCanisters === '0' ? '3' : formState.howManyCanisters === '1' ? '2' : '1';
            let variant;

            // Assign the corresponding variant
            if (formState.howManyCanisters === '3') {
                variant = recommendedProduct.variants[0];
            } else {
                variant = recommendedProduct.variants.find((variant) => variant.title.includes(recommendedCanisterCount));
            }

            if (!variant) return;

            // Update the UI with the recommended product information
            document.querySelectorAll('.recommended-product-title').forEach((element) => {
                element.innerHTML = recommendedProduct.title;
            });

            document.querySelectorAll('.recommended-product-price').forEach((element) => {
                element.innerHTML = `$${Number(variant.price / 100).toFixed(0)}`;
            });

            // Update product images
            const connectionType = formState.canisterType;
            if (!connectionType) return;

            const oneCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-one-canister-image' : '.threaded-one-canister-image';
            const twoCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-two-canister-image' : '.threaded-two-canister-image';
            const threeCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-three-canister-image' : '.threaded-three-canister-image';

            // Hide all images first
            document.querySelectorAll('.product-recommendation-image').forEach(element => element.classList.add('hidden'));
            const selectedNumberOfCanisters = document.getElementById('selected-number-of-canisters');
            if (selectedNumberOfCanisters) {
                selectedNumberOfCanisters.classList.remove('hidden');
            }

            // Then show the appropriate images based on canister count
            if (formState.howManyCanisters === '0') {
                document.querySelectorAll(threeCanisterClass).forEach(element => element.classList.remove('hidden'));
            } else if (formState.howManyCanisters === '1') {
                document.querySelectorAll(twoCanisterClass).forEach(element => element.classList.remove('hidden'));
            } else if (formState.howManyCanisters === '2') {
                document.querySelectorAll(oneCanisterClass).forEach(element => element.classList.remove('hidden'));
            } else if (formState.howManyCanisters === '3') {
                document.querySelectorAll('.refill-box-image').forEach(element => element.classList.remove('hidden'));
                if (selectedNumberOfCanisters) {
                    selectedNumberOfCanisters.classList.add('hidden');
                }
            }

            // Update hidden form fields
            const productType = formState.howManyCanisters === '3' ? 'refill-box' : 'canisters';
            document.getElementById('machine-hidden').value = formState.whatSodaMakerDoYouOwn || 'none';
            document.getElementById('canister-type-hidden').value = formState.canisterType || 'none';
            document.getElementById('canister-count-hidden').value = formState.howManyCanisters || '0';
            document.getElementById('product-recommendation-hidden').value = recommendedProduct.title || 'none';
            document.getElementById('product-recommendation-price-hidden').value = (variant.price / 100).toFixed(0) || '0';
            document.getElementById('product-recommendation-link-hidden').value = window.origin + `/pages/co2-gas?canisterType=${formState.canisterType}&productType=${productType}` || 'none';
        }

        if (key === 'whatSodaMakerDoYouOwn') {
            document.getElementById('machine-hidden').value = value || 'none';
        }
    }

    function loadStateFromSession() {
        const storedState = sessionStorage.getItem('formState');
        if (storedState) {
            formState = JSON.parse(storedState);
            updateUIBasedOnState();
        }
    }

    function updateUIBasedOnState() {
        const urlStep = new URLSearchParams(window.location.search).get('step');
        if (!urlStep) return;

        const currentStepElement = document.querySelector(`[data-step="${urlStep}"]`);
        if (!currentStepElement) return;

        // Only restore state relevant to the current step
        if (urlStep === '4') {
            if (formState.canisterType && formState.howManyCanisters) {
                const connectionType = formState.canisterType;
                const canisterCount = formState.howManyCanisters;

                // Hide all product recommendation images first
                document.querySelectorAll('.product-recommendation-image').forEach(element => element.classList.add('hidden'));
                const selectedNumberOfCanisters = document.getElementById('selected-number-of-canisters');
                if (selectedNumberOfCanisters) {
                    selectedNumberOfCanisters.classList.remove('hidden');
                }

                const oneCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-one-canister-image' : '.threaded-one-canister-image';
                const twoCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-two-canister-image' : '.threaded-two-canister-image';
                const threeCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-three-canister-image' : '.threaded-three-canister-image';

                // Show the appropriate image based on canister count
                if (canisterCount === '0') {
                    document.querySelectorAll(threeCanisterClass).forEach(element => element.classList.remove('hidden'));
                } else if (canisterCount === '1') {
                    document.querySelectorAll(twoCanisterClass).forEach(element => element.classList.remove('hidden'));
                } else if (canisterCount === '2') {
                    document.querySelectorAll(oneCanisterClass).forEach(element => element.classList.remove('hidden'));
                } else if (canisterCount === '3') {
                    document.querySelectorAll('.refill-box-image').forEach(element => element.classList.remove('hidden'));
                    if (selectedNumberOfCanisters) {
                        selectedNumberOfCanisters.classList.add('hidden');
                    }
                }

                transitionToStep4();
            }
        }

        // Show the current step
        document.querySelectorAll('[data-step]').forEach(step => {
            if (step.dataset.step === urlStep) {
                step.classList.remove('opacity-0', 'pointer-events-none');
                step.classList.add('active');
            } else {
                step.classList.add('opacity-0', 'pointer-events-none');
                step.classList.remove('active');
            }
        });

        // Update progress bar if needed
        if (currentStepElement.dataset.progress && progressBarElement) {
            progressBarElement.style.width = `${currentStepElement.dataset.progress}%`;
        }
    }

    // Get Started
    document.getElementById('get-started').addEventListener('click', () => {
        // Clear form state when starting a new quiz
        sessionStorage.removeItem('formState');

        // Initialize progress bar element if not already done
        if (!progressBarElement) {
            progressBarElement = document.getElementById('progress-bar');
        }

        // Replace translate with opacity transition
        document.getElementById('get-started-container').classList.add('opacity-0', 'pointer-events-none');
        document.getElementById('get-started-container').parentElement.classList.remove('min-h-[637px]');
        document.querySelector(`[data-step="1"]`).classList.remove('opacity-0', 'pointer-events-none');
        progressBarElement.style.width = '20%';
        setStepInUrl(1);
        transitionToStep(document.querySelector(`[data-step="1"]`));
    });

    // Step 1
    document.querySelector('fieldset[data-step="1"]').addEventListener('change', (event) => {

        if (event.target.type === 'radio') {
            // Set active class on the selected soda maker
            const sodaMakers = document.querySelectorAll('.soda-machine');
            sodaMakers.forEach((element) => {
                element.classList.remove('active');
            });
            const sodaMaker = event.target.closest('.soda-machine');
            if (sodaMaker) {
                sodaMaker.classList.add('active');
            }

            // Update the state with the selected soda maker
            if (formState.whatBrandOfSodaMakerDoYouOwn === null) {
                const currentBrand = event.target.value;
                updateState('whatBrandOfSodaMakerDoYouOwn', currentBrand);
            }
            updateState('whatSodaMakerDoYouOwn', event.target.value);

            // Initialize canisterTypeElement if not already done
            if (!canisterTypeElement) {
                canisterTypeElement = document.getElementById('canister-type');
            }

            if (machines[event.target.value]) {
                const connectionType = machines[event.target.value].connectionType;
                if (canisterTypeElement) {
                    // Update the text content based on connection type
                    canisterTypeElement.textContent = connectionType === 'easy-connect' ? 'Easy Connect' : 'Threaded';
                }
                updateState('canisterType', connectionType);
            }

            // Make sure the step is marked as active before handling controller change
            const currentStep = event.target.closest('[data-step]');
            if (!currentStep.classList.contains('active')) {
                currentStep.classList.add('active');
            }

            // Get the next step directly from the selected radio button
            const nextStep = event.target.dataset.nextStep;
            if (nextStep) {
                updateStepHistory(currentStep.dataset.step);
                const nextStepElement = document.querySelector(`[data-step="${nextStep}"]`);

                if (nextStepElement) {
                    // First fade out current step
                    currentStep.classList.remove('active');
                    currentStep.classList.add('opacity-0', 'pointer-events-none');

                    // Wait for fade out to complete before showing next step
                    setTimeout(() => {
                        // Add active class to next step
                        nextStepElement.classList.add('active');

                        // Use a nested setTimeout to ensure the opacity transition triggers
                        setTimeout(() => {
                            nextStepElement.classList.remove('opacity-0', 'pointer-events-none');
                        }, 50);

                        if (nextStepElement.dataset.progress && progressBarElement) {
                            progressBarElement.style.width = `${nextStepElement.dataset.progress}%`;
                        }

                        setStepInUrl(nextStep);
                        updateState('currentStep', nextStep);
                    }, 700); // Match this to your transition duration
                }
            } else {
                // Fallback to the original handleControllerChange if no nextStep is found
                handleControllerChange();
            }
        }
    });

    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    const handleSearch = debounce((searchTerm) => {
        searchTerm = searchTerm.toLowerCase().trim();

        machineElements.forEach(machine => {
            const searchableText = `${machine.dataset.machineName} ${machine.dataset.brand}`.toLowerCase();
            machine.style.display = searchableText.includes(searchTerm) ? 'flex' : 'none';
        });
    }, 150);

    searchInput.addEventListener('input', (e) => handleSearch(e.target.value));

    document.addEventListener('click', (e) => {
        if (e.target !== searchInput && !searchInput.contains(e.target) && !brandMachineDropdown.contains(e.target)) {
            searchInput.value = '';
            machineElements.forEach(machine => machine.style.display = 'flex');
            brandMachineDropdown.classList.add('hidden');
        }
    });

    // Step 1a
    document.querySelector('fieldset[data-step="1a"]').addEventListener('change', (event) => {
        if (event.target.name === 'i-dont-see-my-machine-radio') {
            const connectionType = event.target.value;
            updateState('canisterType', connectionType);

            // Initialize canisterTypeElement if not already done
            if (!canisterTypeElement) {
                canisterTypeElement = document.getElementById('canister-type');
            }

            // Update the text content based on connection type
            if (canisterTypeElement) {
                canisterTypeElement.textContent = connectionType === 'easy-connect' ? 'Easy Connect' : 'Threaded';
            }

            // Make sure the step is marked as active before handling controller change
            const currentStep = event.target.closest('[data-step]');
            if (!currentStep.classList.contains('active')) {
                currentStep.classList.add('active');
            }

            // Enable the next button
            handleControllerChange();
        }
    });

    // Step 2
    document.querySelector('fieldset[data-step="2"]').addEventListener('change', (event) => {
        if (event.target.name === 'canister-count-select') {
            updateState('howManyCanisters', event.target.value);
            handleControllerChange();
        }
    });

    // Step 4
    window.displayFizzQuizResults = function (form, submissionResult) {
        const currentStep = document.querySelector('[data-step].active');
        if (currentStep) {
            // First fade out current step
            currentStep.classList.remove('active');
            currentStep.classList.add('opacity-0', 'pointer-events-none');

            // Wait for fade out to complete before showing next step
            setTimeout(() => {
                // Add active class to next step
                const step4Element = document.querySelector(`[data-step="4"]`);
                step4Element.classList.add('active');

                // Use nested setTimeout to ensure opacity transition triggers
                setTimeout(() => {
                    step4Element.classList.remove('opacity-0', 'pointer-events-none');
                    document.getElementById('recommended-product-add-to-cart').classList.remove('opacity-0', 'pointer-events-none');
                }, 50);

                progressBarElement.style.width = '100%';
                setStepInUrl(4);
                updateState('currentStep', 4);

                const recommendedProduct = getProductRecommendations();
                if (recommendedProduct) {
                    // Update variant select and other product information
                    const variantSelect = document.getElementById('variant-select');

                    // Clear existing options
                    variantSelect.innerHTML = '';

                    // Populate variants
                    recommendedProduct.variants.forEach((variant) => {
                        const option = document.createElement('option');
                        option.value = variant.id;
                        const connectionType = formState.canisterType === 'easy-connect' ? 'Easy Connect' : 'Threaded';
                        option.innerHTML = `${variant.title.match(/\d+/)[0]}x ${connectionType} Canister${variant.title.includes('2') ? 's' : ''}`;
                        variantSelect.appendChild(option);
                    });

                    // Select the appropriate variant based on canister count
                    let recommendedVariant;
                    if (formState.howManyCanisters === '0') {
                        recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('3'));
                    } else if (formState.howManyCanisters === '1') {
                        recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('2'));
                    } else if (formState.howManyCanisters === '2') {
                        recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('1'));
                    } else {
                        recommendedVariant = recommendedProduct.variants[0];
                    }

                    if (recommendedVariant) {
                        variantSelect.value = recommendedVariant.id;
                        const addToCartBtn = document.querySelector('.add-to-cart-btn');
                        addToCartBtn.setAttribute('data-variant-id', recommendedVariant.id);
                        const sellingPlanId = (recommendedVariant.selling_plan_allocations || [])[0]?.selling_plan_id || '';
                        addToCartBtn.setAttribute('data-selling-plan', sellingPlanId);
                        const price = (recommendedVariant.price / 100).toFixed(0);
                        addToCartBtn.textContent = `Add to cart - $${price}`;
                        if (typeof updateButtonRulesFromProduct === 'function') {
                            updateButtonRulesFromProduct(addToCartBtn, recommendedProduct);
                        }
                    }
                }
            }, 700); // Match transition duration
        }
    };

    // Step 5
    /* document.getElementById('retake-the-quiz').addEventListener('click', () => {
        sessionStorage.removeItem('formState');
        document.getElementById('fizz-quiz-form').reset();
        progressBarElement.style.width = '20%';
        previousStep = [];
        document.querySelectorAll('[data-step]').forEach((step) => {
            step.classList.add('opacity-0', 'pointer-events-none');
        });
        document.querySelector(`[data-step="1"]`).classList.remove('opacity-0', 'pointer-events-none');
        const url = new URL(window.location);
        url.searchParams.delete('step');
        history.pushState({ step: 1 }, `Step 1`, url);
    }); */

    // Function to update the UI based on canister type selection
    function handleCanisterTypeSelection(step, event) {
        if (event.target.name === 'canister-count-select' || event.target.name === 'canister-count-select-confirmation') {
            updateState('howManyCanisters', event.target.value);
            const select = document.getElementById(event.target.name === 'canister-count-select' ? 'canister-count-select-confirmation' : 'canister-count-select');
            select.value = event.target.value;
            document.getElementById('canister-count-hidden').value = event.target.value;
        } else if (event.target.name === 'i-dont-see-my-machine-radio') {
            updateState('canisterType', event.target.value);
        } else if (event.target.name === 'aqua-fizz-canister-radio') {
            updateState('canisterType', event.target.value);
        }

        const connectionType = formState.canisterType;
        const canisterCount = formState.howManyCanisters;
        const recommendedProduct = getProductRecommendations();
        const canisterCountAndType = document.getElementById('canister-count-and-type');
        const boxDescription = document.getElementById('box-description');

        document.getElementById('canister-count').innerHTML = formState.howManyCanisters;

        let recommendedVariant;
        if (canisterCount === '0') {
            canisterCountAndType.querySelector('span').innerHTML = `3 new full ${formState.canisterType} canisters`;
            recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('3'));
            boxDescription.classList.add('hidden');
        } else if (canisterCount === '1') {
            canisterCountAndType.querySelector('span').innerHTML = `2 new full ${formState.canisterType} canisters`;
            recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('2'));
            boxDescription.classList.add('hidden');
        } else if (canisterCount === '2') {
            canisterCountAndType.querySelector('span').innerHTML = `1 new full ${formState.canisterType} canister`;
            recommendedVariant = recommendedProduct.variants.find((variant) => variant.title.includes('1'));
            boxDescription.classList.add('hidden');
        } else {
            canisterCountAndType.classList.add('hidden');
            recommendedVariant = recommendedProduct.variants[0];
            boxDescription.classList.remove('hidden');
        }

        const oneCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-one-canister-image' : '.threaded-one-canister-image';
        const twoCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-two-canister-image' : '.threaded-two-canister-image';
        const threeCanisterClass = connectionType === 'easy-connect' ? '.easy-connect-three-canister-image' : '.threaded-three-canister-image';

        // Hide all product recommendation images first
        document.querySelectorAll('.product-recommendation-image').forEach(element => element.classList.add('hidden'));
        const selectedNumberOfCanisters = document.getElementById('selected-number-of-canisters');
        if (selectedNumberOfCanisters) {
            selectedNumberOfCanisters.classList.remove('hidden');
        }

        // Show the appropriate image based on canister count
        if (canisterCount === '0') {
            document.querySelectorAll(threeCanisterClass).forEach(element => element.classList.remove('hidden'));
        } else if (canisterCount === '1') {
            document.querySelectorAll(twoCanisterClass).forEach(element => element.classList.remove('hidden'));
        } else if (canisterCount === '2') {
            document.querySelectorAll(oneCanisterClass).forEach(element => element.classList.remove('hidden'));
        } else if (canisterCount === '3') {
            document.querySelectorAll('.refill-box-image').forEach(element => element.classList.remove('hidden'));
            if (selectedNumberOfCanisters) {
                selectedNumberOfCanisters.classList.add('hidden');
            }
        }

        canisterTypeElement.innerHTML = connectionType === 'easy-connect' ? 'Easy Connect' : 'Threaded';

        const productType = canisterCount === '3' ? 'refill-box' : 'canisters';

        // Populate the hidden fields
        document.getElementById('machine-hidden').value = formState.whatSodaMakerDoYouOwn;
        document.getElementById('canister-type-hidden').value = formState.canisterType;
        document.getElementById('canister-count-hidden').value = formState.howManyCanisters;
        document.getElementById('product-recommendation-hidden').value = recommendedProduct.title;
        document.getElementById('product-recommendation-price-hidden').value = (recommendedVariant.price / 100).toFixed(0);
        document.getElementById('product-recommendation-link-hidden').value = window.origin + `/pages/co2-gas?canisterType=${formState.canisterType}&productType=${productType}`;

        if (recommendedProduct) {
            updateVariantSelectAndAddToCartButton(recommendedVariant);
        }
    }

    // Get the product recommendations
    function getProductRecommendations() {
        const canisterType = formState.canisterType;
        const canisterCount = formState.howManyCanisters;

        if (!canisterType || !canisterCount) {
            return null;
        }

        let recommendedProduct;
        if (canisterType === 'easy-connect') {
            if (canisterCount === '3') {
                recommendedProduct = productsData.find((product) => product.tags.includes('easy-connect') && product.tags.includes('refill-box'));
            } else {
                recommendedProduct = productsData.find((product) => product.tags.includes('easy-connect') && product.tags.includes('canisters'));
            }
        } else if (canisterType === 'threaded') {
            if (canisterCount === '3') {
                recommendedProduct = productsData.find((product) => product.tags.includes('threaded') && product.tags.includes('refill-box'));
            } else {
                recommendedProduct = productsData.find((product) => product.tags.includes('threaded') && product.tags.includes('canisters'));
            }
        }

        if (!recommendedProduct) {
            return null;
        }
        return recommendedProduct;
    }

    // Helper function to get query string parameters
    function getQueryStringValue(key) {
        return new URLSearchParams(window.location.search).get(key);
    }

    // Function to set the step in the URL query string
    function setStepInUrl(step) {
        const url = new URL(window.location);
        url.searchParams.set('step', step);
        history.pushState({ step: step }, `Step ${step}`, url);
    }

    // Function to handle loading the correct step based on the URL
    function loadStepFromUrl() {
        const stepFromUrl = getQueryStringValue('step');
        if (stepFromUrl) {
            const stepElement = document.querySelector(`[data-step="${stepFromUrl}"]`);
            if (stepElement) {
                // Hide the get started container
                document.getElementById('get-started-container').classList.add('opacity-0', 'pointer-events-none');
                // Hide the currently active step
                const currentActive = document.querySelector('[data-step].active');
                if (currentActive) {
                    currentActive.classList.remove('active');
                    currentActive.classList.add('opacity-0', 'pointer-events-none');
                }
                // Show the step from the URL
                stepElement.classList.add('active');
                stepElement.classList.remove('opacity-0', 'pointer-events-none');
            }
        } else {
            // If no step in URL, ensure first step is active
            const firstStep = document.querySelector('[data-step="1"]');
            if (firstStep && !document.querySelector('[data-step].active')) {
                firstStep.classList.add('active');
                firstStep.classList.remove('opacity-0', 'pointer-events-none');
            }
        }
    }

    // Function to handle the enabling of the next button based on input change
    function handleControllerChange() {
        const currentStep = document.querySelector('[data-step].active');
        if (!currentStep) return;

        const nextController = currentStep.querySelector('[data-next-controller]:checked, select[data-next-controller], button[data-next-controller]');

        const isControllerValid = nextController &&
            (nextController.type === 'radio' ||
                nextController.type === 'select-one' ||
                nextController.type === 'button');

        if (isControllerValid) {
            updateStepHistory(currentStep.dataset.step);
            let nextStepSelector = currentStep.dataset.nextStep;

            if (nextController) {
                nextStepSelector = nextController.dataset.nextStep;
            }
            const nextStep = document.querySelector(`[data-step="${nextStepSelector}"]`);

            if (nextStep) {
                // First fade out current step
                currentStep.classList.remove('active');
                currentStep.classList.add('opacity-0', 'pointer-events-none');

                // Wait for fade out to complete before showing next step
                setTimeout(() => {
                    // Add active class to next step
                    nextStep.classList.add('active');

                    // Use a nested setTimeout to ensure the opacity transition triggers
                    setTimeout(() => {
                        nextStep.classList.remove('opacity-0', 'pointer-events-none');
                    }, 50);

                    if (nextStep.dataset.progress && progressBarElement) {
                        progressBarElement.style.width = `${nextStep.dataset.progress}%`;
                    }

                    setStepInUrl(nextStepSelector);
                    updateState('currentStep', nextStepSelector);
                }, 700); // Match this to your transition duration
            }
        }
    }

    let timeTracking = {};

    function startStep(step) {
        if (!timeTracking[step]) {
            timeTracking[step] = { startTime: new Date(), endTime: null, duration: null };
        } else {
            timeTracking[step].startTime = new Date(); // reset start time if step is revisited
        }
    }

    function endStep(step) {
        if (timeTracking[step] && timeTracking[step].startTime) {
            timeTracking[step].endTime = new Date();
            timeTracking[step].duration = timeTracking[step].endTime - timeTracking[step].startTime;
            sendTimeToGA(step);
        }
    }

    function sendTimeToGA(step) {
        const duration = timeTracking[step].duration;
        gtag('event', 'Step Duration', {
            'event_category': 'Fizz Quiz',
            'event_label': `Time on Step ${step}`,
            'value': duration
        });
    }

    function transitionToStep(nextStepElement) {
        const currentStep = document.querySelector('[data-step].active');
        if (!currentStep) return;

        // If the nextStepElement has a data-progress attribute, update the progress bar
        if (nextStepElement.dataset.progress && progressBarElement) {
            progressBarElement.style.width = `${nextStepElement.dataset.progress}%`;
        }

        // Update the previousStep stack and the back button state
        if (previousSteps.length > 0) {
            back.classList.remove('btn-disabled');
            back.removeAttribute('disabled');

            // Get the previous step element
            endStep(previousSteps[previousSteps.length - 1]);
        }

        // Update the current step in the state
        updateState('currentStep', nextStepElement.dataset.step);
        previousSteps.push(nextStepElement.dataset.step);
        updateTopBackButton();

        // Update the URL to reflect the current step
        setStepInUrl(nextStepElement.dataset.step);

        startStep(nextStepElement.dataset.step);
    }

    back.addEventListener('click', () => {
        // Prevent multiple rapid clicks
        back.disabled = true;
        setTimeout(() => back.disabled = false, 1000);

        const currentStep = document.querySelector('[data-step].active');
        if (!currentStep) return;

        // Get the previous step from history
        const previousStep = previousSteps[previousSteps.length - 2]; // Get the second to last step
        if (!previousStep) return;

        // Remove the current step from history
        previousSteps.pop();

        const targetStep = document.querySelector(`[data-step="${previousStep}"]`);
        if (!targetStep) return;

        // First fade out current step
        currentStep.classList.remove('active');
        currentStep.classList.add('opacity-0', 'pointer-events-none');

        // Wait for fade out to complete
        setTimeout(() => {
            // Add active class to target step
            targetStep.classList.add('active');

            // Use nested setTimeout to ensure opacity transition triggers
            setTimeout(() => {
                targetStep.classList.remove('opacity-0', 'pointer-events-none');
            }, 50);

            // Update progress bar
            if (targetStep.dataset.progress && progressBarElement) {
                progressBarElement.style.width = `${targetStep.dataset.progress}%`;
            }

            // Update URL and state
            setStepInUrl(previousStep);
            updateState('currentStep', previousStep);
            updateTopBackButton();
        }, 700);
    });

    // For each .back button, add a click event listener to transition to the previous step
    document.querySelectorAll('.back').forEach((button) => {
        button.addEventListener('click', () => {
            back.click();
        });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
        // Check if click is outside both the search input and dropdown
        if (!searchInput?.contains(e.target) && !brandMachineDropdown?.contains(e.target)) {
            // Hide the dropdown
            brandMachineDropdown?.classList.add('hidden');
            // Clear the input
            searchInput.value = '';
            // Show all machines again
            machineElements.forEach(machine => {
                machine.style.display = 'flex';
            });
        }
    });

    // Show/hide top back button based on step changes
    function updateTopBackButton() {
        if (!topBackButton) return; // Add safety check
        if (previousSteps.length > 0) {
            topBackButton.classList.remove('opacity-0', 'pointer-events-none');
        } else {
            topBackButton.classList.add('opacity-0', 'pointer-events-none');
        }
    }

    // Add click handler for top back button
    if (topBackButton) { // Add safety check
        topBackButton.addEventListener('click', () => {
            back.click();
        });
    }

    function updateStepHistory(newStep) {
        if (!previousSteps.includes(newStep)) {
            previousSteps.push(newStep);
            updateTopBackButton();
        }
    }

    // Initialize the UI state
    if (!document.querySelector('[data-step].active')) {
        const firstStep = document.querySelector('[data-step="1"]');
        if (firstStep) {
            firstStep.classList.add('active');
            firstStep.classList.remove('opacity-0', 'pointer-events-none');
        }
    }

    loadStepFromUrl();
    loadStateFromSession();

    if (formState.currentStep === 5) {
        displayFizzQuizResults();
    }

    document.querySelector('button[data-next-controller][data-next-step="1c"]').addEventListener('click', () => {
        handleControllerChange();
    });

    // Add popstate event listener to handle browser navigation
    window.addEventListener('popstate', (event) => {
        const stepFromUrl = getQueryStringValue('step');
        if (stepFromUrl) {
            const currentStep = document.querySelector('[data-step].active');
            const targetStep = document.querySelector(`[data-step="${stepFromUrl}"]`);

            if (currentStep && targetStep) {
                // First fade out current step
                currentStep.classList.remove('active');
                currentStep.classList.add('opacity-0', 'pointer-events-none');

                // Wait for fade out to complete before showing next step
                setTimeout(() => {
                    // Add active class to target step
                    targetStep.classList.add('active');

                    // Use nested setTimeout to ensure opacity transition triggers
                    setTimeout(() => {
                        targetStep.classList.remove('opacity-0', 'pointer-events-none');
                    }, 50);

                    // Update progress bar if needed
                    if (targetStep.dataset.progress && progressBarElement) {
                        progressBarElement.style.width = `${targetStep.dataset.progress}%`;
                    }

                    updateState('currentStep', stepFromUrl);
                }, 700);
            }
        }
    });

    // Show dropdown when input is focused
    searchInput.addEventListener('focus', () => {
        brandMachineDropdown.classList.remove('hidden');
    });

    // Filter dropdown items based on input
    searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase();

        dropdownButtons.forEach(button => {
            const value = button.dataset.value.toLowerCase();
            const brand = (button.dataset.brand || '').toLowerCase();

            if (value.includes(searchTerm) || brand.includes(searchTerm)) {
                button.parentElement.classList.remove('hidden');
                button.classList.remove('hidden');
            } else {
                button.classList.add('hidden');
            }
        });
    });

    // Handle clicking dropdown items
    dropdownButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent event from bubbling up
            const selectedValue = button.dataset.value;
            const selectedBrand = button.dataset.brand;
            searchInput.value = selectedValue;

            if (selectedBrand) {
                // This is a machine button
                const machineRadio = document.querySelector(`input[type="radio"][value="${selectedValue.toLowerCase().replace(/\s+/g, '-')}"]`);
                if (machineRadio) {
                    machineRadio.checked = true;
                    machineRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else {
                // This is a brand button
                machineElements.forEach(machine => {
                    const machineBrand = machine.dataset.brand;
                    machine.style.display = (machineBrand && machineBrand.toLowerCase() === selectedValue.toLowerCase()) ? 'flex' : 'none';
                });
            }
            brandMachineDropdown.classList.add('hidden');
        });
    });

    // Add variant select change handler
    document.getElementById('variant-select')?.addEventListener('change', (event) => {
        const variantId = event.target.value;
        const addToCartBtn = document.querySelector('.add-to-cart-btn');
        const recommendedProduct = getProductRecommendations();
        if (recommendedProduct) {
            const selectedVariant = recommendedProduct.variants.find(v => v.id.toString() === variantId);
            if (selectedVariant) {
                addToCartBtn.setAttribute('data-variant-id', variantId);
                const sellingPlanId = (selectedVariant.selling_plan_allocations || [])[0]?.selling_plan_id || '';
                addToCartBtn.setAttribute('data-selling-plan', sellingPlanId);
                const price = (selectedVariant.price / 100).toFixed(0);
                addToCartBtn.textContent = `Add to cart - $${price}`;
                if (typeof updateButtonRulesFromProduct === 'function') {
                    updateButtonRulesFromProduct(addToCartBtn, recommendedProduct);
                }

                // Update the recommended product price display
                document.querySelectorAll('.recommended-product-price').forEach((element) => {
                    element.innerHTML = `$${price}`;
                });

                // Hide all product recommendation images first
                document.querySelectorAll('.product-recommendation-image').forEach(element => element.classList.add('hidden'));
                const selectedNumberOfCanisters = document.getElementById('selected-number-of-canisters');
                if (selectedNumberOfCanisters) {
                    selectedNumberOfCanisters.classList.remove('hidden');
                }

                // Get canister count from variant title
                const canisterCount = selectedVariant.title.match(/\d+/)[0];
                const connectionType = formState.canisterType;

                // Show the appropriate image based on canister count and connection type
                if (canisterCount === '1') {
                    document.querySelectorAll(connectionType === 'easy-connect' ? '.easy-connect-one-canister-image' : '.threaded-one-canister-image')
                        .forEach(element => element.classList.remove('hidden'));
                } else if (canisterCount === '2') {
                    document.querySelectorAll(connectionType === 'easy-connect' ? '.easy-connect-two-canister-image' : '.threaded-two-canister-image')
                        .forEach(element => element.classList.remove('hidden'));
                } else if (canisterCount === '3') {
                    document.querySelectorAll(connectionType === 'easy-connect' ? '.easy-connect-three-canister-image' : '.threaded-three-canister-image')
                        .forEach(element => element.classList.remove('hidden'));
                } else if (canisterCount === '4') {
                    document.querySelectorAll(connectionType === 'easy-connect' ? '.easy-connect-four-canister-image' : '.threaded-four-canister-image')
                        .forEach(element => element.classList.remove('hidden'));
                }
            }
        }
    });
});